import type { RoomExtra } from '@features/rooms';
import {
  buildExtrasBasketPayload,
  ExtraFormEntry,
  ExtraOptionSelectionState,
} from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStepV2/utils';
import { OvernightPackageRoomExtra, OvernightPackageRoomExtras } from '../types';

const toOptionIndex = (option: OvernightPackageRoomExtra['option']) =>
  typeof option === 'object' && option !== null ? option.value : option;

export const mapPackageExtrasToBasket = (
  availableExtras: RoomExtra[],
  formExtras: OvernightPackageRoomExtras
) => {
  const entries: (ExtraFormEntry | undefined)[] = (formExtras ?? []).map(
    (entry) => entry && { ...entry, option: toOptionIndex(entry.option) }
  );
  const optionSelections = Object.fromEntries(
    entries.map((entry, index) => [index, entry?.optionSelections])
  ) as Record<number, ExtraOptionSelectionState | undefined>;

  return buildExtrasBasketPayload(availableExtras, entries, optionSelections);
};
